import React from "react";
import { Link } from "react-router-dom";

const NonAdminMessage = () => {
  return <span>Please contact admin to activate</span>;
};

const AdminMessage = () => {
  return (
    <span>
      Please click <Link to="/admin/master/sites">here</Link> to activate.
    </span>
  );
};

export default function AlertBox({ role, reminder, handleDismiss, remaining }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: `${remaining > 0 ? "space-between" : "center"}`,
        background: `${remaining <= 1 ? "#ed2241" : "#fa8c15"}`,
        alignItems: "center",
        padding: "0px 15px",
        minHeight: "40px",
        minWidth: "600px",
        boxShadow: "0 0 5px 5px rgba(0, 0, 0, 0.03)",
        borderRadius: "0px 0px 12px 12px",
      }}
    >
      <div>
        <p style={{ margin: 0, fontSize: "16px" }}>
          {" "}
          {`${reminder.message} `}
          {role === "ADMIN" ? <AdminMessage /> : <NonAdminMessage />}
        </p>
      </div>
      <div>
        {remaining > 0 && (
          <button
            onClick={handleDismiss}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            X
          </button>
        )}
      </div>
    </div>
  );
}
